import { ReactNode } from 'react';
import { validateEmail } from './validateEmail';
import { validatePassword } from './validatePassword';

export function validateLogin(payload: {
    email: string;
    password: string;
}): { email: ReactNode; password: ReactNode } | null {
    const { email = '', password = '' } = payload;
    return { email: validateEmail(email), password: validatePassword(password) };
}
